import { getAllOnboardingCardsShownStatus } from './getAllOnboardingCardsShownStatus';
import { getDaysSinceUserSignup } from 'mini-common-utils/lib/utils/getDaysSinceUserSignup';

export const isOnboardingComplete = (): boolean => {
    const diffInDays = getDaysSinceUserSignup();

    if (diffInDays >= 30) {
        return true;
    }
    return getAllOnboardingCardsShownStatus();
};
